export function formatDate(date: Date): string {
  return date.toISOString().split('T')[0]
}

export function getDefaultDateRange(): { start_date: string; end_date: string } {
  const end = new Date()
  const start = new Date()
  start.setDate(start.getDate() - 30) // Last 30 days by default

  return {
    start_date: formatDate(start),
    end_date: formatDate(end),
  }
}

export function parseDate(dateStr: string): Date {
  return new Date(dateStr + 'T00:00:00')
}

export function formatDisplayDate(dateStr: string): string {
  const date = parseDate(dateStr)
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export function getDateRangePresets(): Array<{
  label: string
  getDates: () => { start_date: string; end_date: string }
}> {
  return [
    {
      label: 'Last 7 days',
      getDates: () => {
        const end = new Date()
        const start = new Date()
        start.setDate(start.getDate() - 7)
        return { start_date: formatDate(start), end_date: formatDate(end) }
      },
    },
    {
      label: 'Last 30 days',
      getDates: () => {
        const end = new Date()
        const start = new Date()
        start.setDate(start.getDate() - 30)
        return { start_date: formatDate(start), end_date: formatDate(end) }
      },
    },
    {
      label: 'Last 90 days',
      getDates: () => {
        const end = new Date()
        const start = new Date()
        start.setDate(start.getDate() - 90)
        return { start_date: formatDate(start), end_date: formatDate(end) }
      },
    },
    {
      label: 'This month',
      getDates: () => {
        const now = new Date()
        const start = new Date(now.getFullYear(), now.getMonth(), 1)
        const end = new Date()
        return { start_date: formatDate(start), end_date: formatDate(end) }
      },
    },
    {
      label: 'Last month',
      getDates: () => {
        const now = new Date()
        const start = new Date(now.getFullYear(), now.getMonth() - 1, 1)
        const end = new Date(now.getFullYear(), now.getMonth(), 0)
        return { start_date: formatDate(start), end_date: formatDate(end) }
      },
    },
  ]
}
